import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import Select from "react-select";
import api from "../../Utils/api";
import { useSelector } from "react-redux";

export default function AddFeed({ isOpen, onClose }) {
  const [formData, setFormData] = useState({
    location: "",
    content: "",
    requireConfirm: false,
    allowComment: true,
    type: "main_post",
    media: null,
  });
  const [users, setUsers] = useState([]);
  const [locations, setLocations] = useState([]);
  const user = useSelector((state) => state.user.user);

  const fileInputRef = useRef(null); // Ref to trigger file input click

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;

    if (type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        [name]: checked,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  useEffect(() => {
    getUsers();
    getLocations();
  }, []);

  const getUsers = async () => {
    try {
      const response = await api.get("/user");
      setUsers(response.data.users.filter((u) => !u.archive));
    } catch (error) {
      console.error(error);
    }
  };

  const getLocations = async () => {
    try {
      const response = await api.get("/location");
      setLocations(response.data.locations);
    } catch (error) {
      console.error(error);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setFormData((prev) => ({
      ...prev,
      media: file,
    }));
  };

  const handleAttachmentClick = () => {
    fileInputRef.current.click(); // Programmatically trigger file input
  };

  const submitPost = async (event) => {
    event.preventDefault();
    if (!formData.location || !formData.content) {
      toast.error("Location and content are required");
      return;
    }

    // console.log(formData);

    const formDataToSend = new FormData();
    formDataToSend.append("location", formData.location);
    formDataToSend.append("content", formData.content);
    formDataToSend.append("confirmationRequired", formData.requireConfirm);
    formDataToSend.append("commentsEnabled", formData.allowComment);
    formDataToSend.append("type", formData.type);
    if (formData.media) {
      formDataToSend.append("media", formData.media);
    }
    formDataToSend.append("author", user._id);

    try {
      const res = await api.post("/newsfeed/admin", formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (res.data.success) {
        toast.success("Post created successfully");
        closeModal();
      } else {
        toast.error("Failed to create post");
      }
    } catch (error) {
      console.error(error);
      toast.error("Error creating post");
    }
  };

  const clearFields = () => {
    setFormData({
      users: [],
      locations: [],
      content: "",
      requireConfirm: false,
      allowComment: true,
      type: "post",
      media: null,
    });
  };

  const closeModal = () => {
    clearFields();
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-[500]">
      <div className="bg-white rounded-lg w-full max-w-lg p-6 shadow-lg">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-semibold text-gray-800">Create post</h2>
          <button
            onClick={closeModal}
            className="text-2xl text-gray-500 hover:text-gray-800"
          >
            ×
          </button>
        </div>

        {/* <Select
          value={formData.users}
          onChange={(sops) => setFormData((prev) => ({ ...prev, users: sops }))}
          isMulti
          options={users.map((user) => ({
            value: user._id,
            label: user.preferredName,
          }))}
          className="mb-4"
          placeholder="Select users"
        /> */}

        <Select
          value={formData.locations}
          onChange={(sops) =>
            setFormData((prev) => ({ ...prev, location: sops.value }))
          }
          options={locations.map((location) => ({
            value: location._id,
            label: location.name,
          }))}
          className="mb-4"
          placeholder="Select locations"
        />

        <textarea
          placeholder="What's happening?"
          value={formData.content}
          name="content"
          onChange={handleInputChange}
          className="w-full border border-gray-300 rounded-md p-3 h-28 resize-none mb-4 focus:outline-none focus:ring-2 focus:ring-gray-500"
        ></textarea>

        <div className="flex items-center gap-2 border border-gray-200 bg-gray-50 p-3 rounded-md mb-4">
          <button
            onClick={handleAttachmentClick}
            className="text-gray-700 font-semibold text-[0.875em] bg-gray-100 py-1.5 px-2 rounded-md"
          >
            Attachment
          </button>
          <input
            type="file"
            name="media"
            onChange={handleFileChange}
            accept="image/*,video/*,.pdf"
            className="hidden"
            ref={fileInputRef}
          />
          <span className="text-sm text-gray-500 ml-2">
            {formData.media
              ? formData.media.name
              : "Attach images, video, or PDFs"}
          </span>
        </div>

        {/* <div className="flex items-center justify-between mb-6 text-sm">
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              name="requireConfirm"
              checked={formData.requireConfirm}
              onChange={handleInputChange}
              className="accent-gray-600"
            />
            Require confirmation
          </label>
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              name="allowComment"
              checked={formData.allowComment}
              onChange={handleInputChange}
              className="accent-gray-600"
            />
            Allow comments
          </label>
        </div> */}

        <div className="text-right">
          <button
            onClick={submitPost}
            className="bg-gray-600 text-white px-6 py-2 rounded-md hover:bg-gray-700"
          >
            Post
          </button>
        </div>
      </div>
    </div>
  );
}
